import PosthogService from '~/services/posthog/PosthogService';
import { TTermsPopupSource } from './types';

export interface ITermsPopupViewedPayload {
  source: TTermsPopupSource;
}

/**
 * Fires when the Terms & Conditions popup is shown
 * Event: dental_portal:terms_popup:viewed
 */
export function fireTermsPopupViewed(payload: ITermsPopupViewedPayload): void {
  PosthogService.getInstance().track('dental_portal:terms_popup:viewed', {
    source: payload.source,
  });
}
